import { render, staticRenderFns } from "./dockIndex.vue?vue&type=template&id=82d708fe&scoped=true"
import script from "./dockIndex.vue?vue&type=script&lang=js"
export * from "./dockIndex.vue?vue&type=script&lang=js"
import style0 from "./dockIndex.vue?vue&type=style&index=0&id=82d708fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d708fe",
  null
  
)

export default component.exports